<template>

  <accordion-simple-item title="Neues Magazin" :flex="true">
    <div class="flex flex-grow flex-col h-full py-6">
      <spinner v-if="isLoading" class="col-span-4 w-full mt-6"/>

      <div v-if="!isLoading" class="flex flex-grow flex-col gap-2">

        <div class="grid grid-cols-[6rem,1fr] items-center gap-y-2 max-w-full flow-grow">

          <div>Projekt:</div>
          <select class="border p-1 w-full" v-model="projektId"
                  :class="{'border border-red-500': showError && isProjectMissing}" data-ui="select-project">
            <option v-for="project in projectData.projects" :key="project.projectId" :value="project.projectId">
              {{ project.name }}
            </option>
          </select>


          <div>Name:</div>
          <input class="border p-1 w-full"
                 v-model="magazineName"
                 :class="{'border border-red-500': showError && isMagazineNameMissing}"
                 data-ui="input-project-name">

          <div>Magazin typen:</div>
          <select class="border p-1 w-full" v-model="magazineTypeID"
                  :class="{'border border-red-500': showError && isMagazineTypeMissing}"
                  data-ui="select-magazine-type">
            <option v-for="magazine in magazinTypes" :value="magazine.magazineTypeId">
              {{ magazine.magazineTypeTitle }}
            </option>
          </select>

          <div>Drucknummer:</div>
          <input class="border p-1 w-full" data-ui="printNumber" v-model="printNumber">
        </div>


        <tabs v-model="activeTab" :style="'white'">
          <tab :title="'Erstellen'">
            <div class="flex mt-2">
              <span class=" w-[150px] p-1">Format:</span>
              <select class="border p-1 flex-grow " v-model="selectedSize" data-ui="select-format">
                <option value="A1">A1</option>
                <option value="A2">A2</option>
                <option value="A3">A3</option>
                <option value="A4">A4</option>
                <option value="A5">A5</option>
              </select>
            </div>

            <div class="w-full mt-2 flex ">

              <button class="p-1 w-1/2 hover:bg-active hover:text-white cursor-pointer"
                      @click="changeFormart('Hochformart')" data-ui="Hochformart"
                      :class="{ 'bg-active text-white': selectedOption === 'Hochformart', 'bg-trader-gray text-trader-darker-gray': selectedOption !== 'Hochformart' }">
                Hochformart
              </button>
              <button class="p-1 w-1/2" data-ui="Querformart"
                      @click="changeFormart('Querformart')"
                      :class="{ 'bg-active text-white': selectedOption === 'Querformart', 'bg-trader-gray text-trader-darker-gray': selectedOption !== 'Querformart' }">
                Querformart
              </button>
            </div>

            <div class="mt-2 flex">
              <span class=" w-[150px] p-1">Breite in mm:</span>
              <input class="border p-1 flex-grow " v-model="widthInMm" data-ui="input-width-value"
                     :readonly="selectedSize !== 'custom'">
            </div>
            <div class="mt-2 flex">
              <span class=" w-[150px] p-1">Höhe in mm:</span>
              <input class="border p-1 flex-grow " v-model="heightInMm" data-ui="input-height-value"
                     :readonly="selectedSize !== 'custom'">
            </div>
            <div class="mt-2 flex">
              <span class=" w-[150px] p-1">Seiten Anzahl:</span>
              <input class="border p-1 flex-grow " v-model="pageCount" data-ui="input-page-value">
            </div>
          </tab>

          <tab :title="'Duplizieren'">
            <div class="mt-2 flex">
              <span class=" w-[150px] p-1">Inhalte kopieren:</span>
              <input type="checkbox" v-model="copyData" data-ui="copyData">
            </div>
            <div class="mt-2 flex">
              <span class=" w-[150px] p-1">EKB mit kopieren:</span>
              <input type="checkbox" v-model="copyPurchaser" data-ui="copyPurchaser">
            </div>
            <div class="mt-2 w-full">
              <span class=" w-full p-1  mb-1 inline-block">Magazin: </span>
              <select class="border p-1 w-full inline-block" v-model="createMagazineId" data-ui="select-magazine">
                <optgroup v-for="project in projectData.projects" :key="project.projectId" :label="project.name">
                  <option v-for="magazine in project.magazines" :key="magazine.magazineId"
                          :value="magazine.magazineId">
                    {{ magazine.name }}
                  </option>
                </optgroup>
              </select>
            </div>
          </tab>
        </tabs>
        <div class="">
          <button
              class="p-1 bg-white mb-4 w-full hover:bg-trader-blue hover:text-white"
              @click="newMagazine" data-ui="create-new-magazine-button">Zum Projekt Hinzufügen
          </button>
          <div v-if="isProjectMissing">
            <span style="color:red">Bitte Projekt auswählen</span>
          </div>
          <div v-if="isMagazineNameMissing">
            <span style="color:red">Bitte Namen angeben</span>
          </div>
          <div v-if="isMagazineTypeMissing">
            <span style="color:red">Bitte den Magazin Typen auswählen</span>
          </div>
        </div>
      </div>
    </div>
  </accordion-simple-item>

</template>

<script>
import TRInput from "@/components/Base/TRInput.vue";
import {mapState} from "vuex";
import AccordionItem from "@/components/Accordion/AccordionItem.vue";
import AccordionSimpleItem from "@/components/Accordion/AccordionSimpleItem.vue";
import router from "@/router";
import SignalBus from "@/application/SignalBus";
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import tabs from "@/components/Tabs/Tabs.vue";
import tab from "@/components/Tabs/Tab.vue";
import Spinner from "@/components/Base/Spinner.vue";
import {eventBus} from "@/application/EventBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";

export default {
  name: "SPurchaser",
  data() {
    return {
      printNumber: "",
      isLoading: false,
      magazineName: "",
      magazineTypeID: 0,
      selectedSize: "A4",
      selectedOption: "Hochformart",
      widthInMm: "210",
      heightInMm: "297",
      pageCount: 0,
      copyData: false,
      copyPurchaser: false,
      createMagazineId: 0,
      activeTab: 0,
      showError: false,
      isProjectMissing: false,
      isMagazineNameMissing: false,
      isMagazineTypeMissing: false,
      projectData: {projects: []},
      magazinTypes: [],
      projektId: 0,
      magazineId: 0,
    }
  },
  components: {
    Spinner, tab, tabs,
    AccordionSimpleItem,
    AccordionItem,
    TRInput,
  },
  getProjectId: {
    type: Function,
    default: () => {
    }
  },
  computed: {
    ...mapState('user', ['userData']),
    filteredMarkets() {
      if (!this.markets) {
        // Hier könnten Sie ein leeres Array zurückgeben oder eine andere Logik implementieren
        return [];
      }
      return this.markets.filter(market =>
          market.name.toLowerCase().includes(this.marketsSearch.toLowerCase()) ||
          market.description.toLowerCase().includes(this.marketsSearch.toLowerCase())
      );
    },
  },
  methods: {
    async getMagazineTypes() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query getMagazineTypes {
              getMagazineTypes {
                magazineTypeId
                magazineType
                magazineTypeTitle
                supportMarkets

              }
            }
          `
        });

        this.magazinTypes = response.data.getMagazineTypes;

      } catch (error) {
        console.error("Fehler beim Abrufen der magazineTypes:", error);
      }
    },
    async getProjects() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query GetProjectDetails {
              projects {
                projectId
                name
                magazines {
                  magazineId
                  name
                  numberOfPages
                }
              }
            }
          `
        });
        this.projectData = response.data;
      } catch (error) {
        console.error("Fehler beim Abrufen der Projektdaten:", error);
      }
    },
    updateSize() {
      // Hier können Sie die Breite und Höhe basierend auf der ausgewählten Option aktualisieren

      let sizes = {
        A1: {width: 594, height: 841},
        A2: {width: 420, height: 594},
        A3: {width: 297, height: 420},
        A4: {width: 210, height: 297},
        A5: {width: 148, height: 210},
      };

      if (this.selectedSize in sizes) {
        const sideA = sizes[this.selectedSize].width;
        const sideB = sizes[this.selectedSize].height;

        if (this.selectedOption === "Hochformart") {
          this.widthInMm = sideA;
          this.heightInMm = sideB;
        } else {
          this.widthInMm = sideB;
          this.heightInMm = sideA;
        }
      }
    },
    async newMagazine() {
      this.isProjectMissing = !this.projektId;
      this.isMagazineTypeMissing = !this.magazineTypeID;
      this.isMagazineNameMissing = !this.magazineName;

      if (this.isProjectMissing || this.isMagazineTypeMissing || this.isMagazineNameMissing) {
        this.showError = true;
      } else {
        this.showError = false;
        this.isLoading = true;
        let mmW = parseInt(this.widthInMm);
        let mmH = parseInt(this.heightInMm);
        const magazineData = {
          projektId: this.projektId,
          magazineId: this.createMagazineId,
          magazineName: this.magazineName,
          selectedSize: this.selectedSize,
          mmW: mmW,
          mmH: mmH,
          pageCount: this.pageCount,
          magazineTypeID: this.magazineTypeID,
          copyData: this.copyData,
          copyPurchaser: this.copyPurchaser,
          formart: this.selectedOption,
          printNumber: this.printNumber,
        };


        const mutation = gql`
        mutation createMagazine($magazine: MagazineInput!) {
          createMagazine(magazine: $magazine) {
          success
          code
      }
    }
    `;

        try {
          const variables = {magazine: magazineData};
          const {data} = await apolloClient.mutate({mutation, variables});
          
          if (data.createMagazine.code == "NO_TEMPLATE_FOUND") {

            eventBus.openModal(SuccessConfirmation);
            eventBus.setData({
              title: "Magazine konnte nicht erstellt werden",
              message: "Erstellen nicht möglich. Für diesen Magazintypen gibt es kein Standard Seitentemplate",
            });

          } else {
            this.resetMagazineData();
            SignalBus.emit("sidebar-reload-magazine");
          }
        } catch (error) {
          console.error("Fehler beim Erstellen des Magazins", error);
        } finally {
          this.isLoading = false;
        }
      }
    },
    //TODO change toggle names to what they do
    changeFormart(option) {
      this.selectedOption = option;
    },
    async getAllMarkets() {
      const query = gql`
        query getAllMarkets {
          getAllMarkets  {
            marketId
            name
            description
            isActive
          }

        }
      `;
      try {
        const {data} = await apolloClient.query({query});
        this.markets = data.getAllMarkets;
      } catch (error) {
        console.error(error);
      }
    },
    navigateTo(route, params = {}) {
      let path = route;
      // Aufbau des Pfades basierend auf übergebenen Parametern
      if (Object.keys(params).length) {
        const paramParts = Object.keys(params).map(key => params[key]);
        path += '/' + paramParts.join('/');
      }
      router.push(path);
      if (route.includes('page')) {
        SignalBus.emit("sidebar-reload-project_date");
      }
      if (route.includes('template')) {
        this.pageTemplateId = params.templateId;
      }
    },
    resetMagazineData() {
      this.pageCount = '1';
      this.magazineName = '';
      this.copyData = false;
      this.copyPurchaser = false;
      this.selectedSize = 'A4';
      this.selectedOption = 'Hochformart';
      this.widthInMm = '210';
      this.heightInMm = '297';
      this.projektId = '';
      this.magazineTypeID = '';
      this.printNumber = '';
    },
  },
  mounted() {
    this.getProjects();
    this.getMagazineTypes();
    SignalBus.connect(this, "sidebar-reload-projects", this.getProjects);
  },
  beforeUnmount() {
    SignalBus.disconnectAllFromParent(this);
  },
  watch: {
    selectedSize() {
      // Wenn sich die ausgewählte Größe ändert, die Größen in mm aktualisieren
      this.updateSize();
    },
    selectedOption() {
      // Wenn sich die ausgewählte Größe ändert, die Größen in mm aktualisieren
      this.updateSize();
    },

  },
}
</script>